// extracted by mini-css-extract-plugin
export var active = "_22-d";
export var blink = "_22-e";
export var container = "_22-5";
export var controls = "_22-0";
export var controlsRight = "_22-1";
export var fakeCursor = "_22-c";
export var hidden = "_22-b";
export var quillContainerSmall = "_22-7";
export var quillEditor = "_22-6";
export var quillEditorSmall = "_22-8";
export var quillFormatButtons = "_22-a";
export var quillToolbar = "_22-9";
export var removePadding = "_22-2";
export var state = "_22-3";
export var stateTitle = "_22-4";